import React from "react";
import {
  Box,
  InputAdornment,
  TextField,
  SearchIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TextFieldWithStartAdorn = () => {
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"textfield with Start icon"}
        language={"js"}
        value={"    <TextField\n" +
            "          label=\"Outlined\"\n" +
            "          placeholder={\"search\"}\n" +
            "          InputProps={{\n" +
            "            startAdornment: (\n" +
            "              <InputAdornment position=\"start\">\n" +
            "                <SearchIcon fontSize={\"small\"} />\n" +
            "              </InputAdornment>\n" +
            "            ),\n" +
            "          }}\n" +
            "        />\n\n\n" +
            "        <TextField\n" +
            "          label=\"Filled\"\n" +
            "          variant=\"filled\"\n" +
            "          placeholder={\"search\"}\n" +
            "          InputProps={{\n" +
            "            startAdornment: (\n" +
            "              <InputAdornment position=\"start\">\n" +
            "                <SearchIcon fontSize={\"small\"} />\n" +
            "              </InputAdornment>\n" +
            "            ),\n" +
            "          }}\n" +
            "        />\n\n\n" +
            "        <TextField\n" +
            "          label=\"Standard\"\n" +
            "          variant=\"standard\"\n" +
            "          placeholder={\"search\"}\n" +
            "          InputProps={{\n" +
            "            startAdornment: (\n" +
            "              <InputAdornment position=\"start\">\n" +
            "                <SearchIcon fontSize={\"small\"} />\n" +
            "              </InputAdornment>\n" +
            "            ),\n" +
            "          }}\n" +
            "        />"}
      >
        <TextField
          label="Outlined"
          placeholder={"search"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize={"small"} />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Filled"
          variant="filled"
          placeholder={"search"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize={"small"} />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Standard"
          variant="standard"
          placeholder={"search"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize={"small"} />
              </InputAdornment>
            ),
          }}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default TextFieldWithStartAdorn;
